import React from 'react';
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import { ThemeProvider } from '@emotion/react';

function withTheme(WrappedComponent, theme = 'v2') {
  return (props) => {
    return (
      <ThemeProvider theme={PAYPAL_THEME}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    );
  };
}

export default withTheme;
